import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { AuthenticatedRoutingModule } from './authenticated-routing.module';
import { AuthenticatedContainerComponent } from './components/authenticated-container/authenticated-container.component';
import { SharedModule } from '../_shared/shared.module';
import { MaterialModule } from '../_shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPrintModule } from 'ngx-print';
import { GmvehiclesComponent } from './components/gmvehicles/gmvehicles.component';
import { VehicleListComponent } from './components/gmvehicles/vehicle-list/vehicle-list.component';
import { RedeemPointsComponent } from './components/redeem-points/redeem-points.component';
import { CardBannerComponent } from './components/card-banner/card-banner.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { FaqComponent } from '../_shared/components/faq/faq.component';


@NgModule({
    declarations: [
        DashboardComponent,
        FaqComponent,
        RedeemPointsComponent,
        AuthenticatedContainerComponent,
        GmvehiclesComponent,
        VehicleListComponent,
        CardBannerComponent
    ],
  imports: [
    CommonModule,
    AuthenticatedRoutingModule,
    SharedModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    NgxPrintModule,
    NgOptimizedImage
  ],
    providers: []
})
export class AuthenticatedModule {}
